import {
  CreateAssignmentInputSchema,
  PaginatedAssignmentsSchema,
  AssignmentSchema,
  UpdateAssignmentInputSchema,
  ClassSchema,
  CreateClassInputSchema,
  UpdateClassInputSchema,
  PaginatedClassesSchema,
  StudentSchema,
  CreateStudentInputSchema,
  UpdateStudentInputSchema,
  PaginatedStudentsSchema,
} from "../schemas";
import { z } from "zod";

export const ApiErrorSchema = z.object({
  message: z.string(),
  code: z.string().optional()
});

export const ListAssignmentsResponseSchema = PaginatedAssignmentsSchema;
export const CreateAssignmentRequestSchema = CreateAssignmentInputSchema;
export const AssignmentResponseSchema = AssignmentSchema;
export const UpdateAssignmentRequestSchema = UpdateAssignmentInputSchema.partial();

export const ListClassesResponseSchema = PaginatedClassesSchema;
export const CreateClassRequestSchema = CreateClassInputSchema;
export const ClassResponseSchema = ClassSchema;
export const UpdateClassRequestSchema = UpdateClassInputSchema;

export const ListStudentsResponseSchema = PaginatedStudentsSchema;
export const CreateStudentRequestSchema = CreateStudentInputSchema;
export const StudentResponseSchema = StudentSchema;
export const UpdateStudentRequestSchema = UpdateStudentInputSchema;

export type ApiError = z.infer<typeof ApiErrorSchema>;

